import { Divider, Stack, Typography } from "@mui/material";
import { PeopleIcon, PoliciesIcon, PracticesIcon } from "../../../@lib/icons";

function OurServices({ translator }: any) {
  return (
    <>
      <Stack
        sx={{
          mx: {
            xs: 2,
            sm: 4,
            md: 12,
            lg: 12,
            xl: 12,
          },
        }}
      >
        <Typography variant="h5" color={"#00AAB0"}>
          {translator("navbar.Our Focus")?.toUpperCase()}
        </Typography>
        <Typography variant="h3" mt={1}>
          {translator("landingPage.What you will find here")}
        </Typography>
        <Stack
          p={10}
          my={10}
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
          }}
        >
          <Typography variant="h5" sx={{ display: "flex", alignItems: "end" }}>
            <div style={{ marginRight: "8px" }}>
              {" "}
              <PoliciesIcon />
            </div>{" "}
            {translator("Policies")}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.The Policies section of the Niyel Tracker provides comprehensive, up-to-date information on the legislative and regulatory frameworks that shape our focus areas."
            )}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.We not only track the current state of policies but also analyse the historical evolution of the sector, looking back 5 to 10 years, depending on the data availability. This allows us to understand long-term trends, identify shifts, and anticipate future developments."
            )}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.By monitoring these changes, advocates and decision-makers are equipped to better plan, respond, and influence legislation for sustainable progress."
            )}
          </Typography>
          <Divider sx={{ backgroundColor: "#E4E7EC", margin: "30px 0px" }} />
          <Typography variant="h5" sx={{ display: "flex", alignItems: "end" }}>
            <div style={{ marginRight: "8px" }}>
              {" "}
              <PracticesIcon />
            </div>{" "}
            {translator("Practices")}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.In the Practices section, we examine the implementation and operational realities of policies, including how budgets are allocated and executed."
            )}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.We track shifts in institutional behavior, monitor the effectiveness of practices, and analyze financial commitments to understand whether resources are being used as intended."
            )}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.By assessing these dynamics, stakeholderscan identify gaps between policy intentions and on-the-ground outcomes, ensuring that advocacy efforts push for more effective and equitable practices."
            )}
          </Typography>
          <Divider sx={{ backgroundColor: "#E4E7EC", margin: "30px 0px" }} />
          <Typography variant="h5" sx={{ display: "flex", alignItems: "end" }}>
            <div style={{ marginRight: "8px" }}>
              {" "}
              <PeopleIcon />
            </div>{" "}
            {translator("People")}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.The People section maps the ever-changing networks of decision-makers, influencers, and key stakeholders."
            )}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.This area highlights who holds power, tracks movements within these networks, and reveals connections that influence outcomes in our focus areas. We also look at how they have contributed to or hindered policies or practices."
            )}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.By understanding the human element behind policy and practice, advocates can strategically engage with the right individuals to advance their causes and foster collaboration"
            )}
          </Typography>
          <Divider sx={{ backgroundColor: "#E4E7EC", margin: "30px 0px" }} />
          <Typography variant="h5" sx={{ display: "flex", alignItems: "end" }}>
            <div style={{ marginRight: "8px" }}>
              {" "}
              <PeopleIcon />
            </div>{" "}
            {translator("landingPage.Perceptions (Coming Soon)")}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.The Perceptions section will offer insights into how policies and practices are received bycommunities and stakeholders. It will track public sentiment, attitudes, and the culturalnarratives surrounding key issues."
            )}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={2}>
            {translator(
              "landingPage.Understanding perceptions is crucial for developing advocacy strategies that resonate and mobilize support, as it reflects the values, concerns, and priorities of the people most affected."
            )}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
}

export { OurServices };
